import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../api/api';
import authApi from '../api/authApi';
import { queryKeys } from './queryKeys';

export const useInfo = () => {
  return useQuery({
    queryKey: queryKeys.info(),
    queryFn: async () => {
      const response = await api.get('/info');
      return response.data?.data || response.data;
    },
  });
};

export const useUpdateInfo = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload) => {
      const response = await authApi.post('/info', payload);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.info() });
    },
  });
};
